export interface PricingItem {
    id: string;
    title: string;
    slug: string;
    content: string;
    price: string;
    imageKey: string;
    icon: string;
    ctas: { label: string; href: string }[];
    soldOut?: boolean;
    isTemporarilyClosed?: boolean;
    note?: string;
}

export const pricingData: PricingItem[] = [
    {
        id: "piloto",
        title: "OFFROAD",
        slug: "offroad",
        content: "Quedan pocas plazas disponibles",
        price: "100 €",
        imageKey: "piloto-off", // Placeholder
        icon: "landscape",
        ctas: [{ label: "Inscripción", href: "https://youevent.es/sport/inscripcion_competicion.asp?interfaz_minima=true&id_competicion=8585" }],
    },
    {
        id: "piloto-roadbook",
        title: "ROAD",
        slug: "road",
        content: "Descubre la inmensidad de los Monegros en una ruta épica que te llevará desde el corazón del desierto hasta los Pirineos por las mejores carreteras de asfalto.",
        price: "95 €",
        imageKey: "piloto-on", // Placeholder
        icon: "route",
        ctas: [{ label: "Inscripción", href: "https://youevent.es/sport/inscripcion_competicion.asp?interfaz_minima=true&id_competicion=8585" }],
    },
    {
        id: "acompanante",
        title: "Acompañante",
        slug: "acompanante",
        content: "Acceso a zonas comunes. Incluye cenas y avituallamientos.",
        price: "85 €",
        imageKey: "acompanante", // Placeholder
        icon: "group",
        ctas: [{ label: "Inscripción", href: "https://youevent.es/sport/inscripcion_competicion.asp?interfaz_minima=true&id_competicion=8585" }],
    },
];

